import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import {
  ADD_NEW_LABTESTSAMPLE,
  DELETE_LABTESTSAMPLE,
  GET_LABTESTSAMPLES,
  UPDATE_LABTESTSAMPLE,
  UPDATE_LABTESTSAMPLE_STATUS
} from "./actionTypes";

import {
  addLabTestSampleFail,
  addLabTestSampleSuccess,
  deleteLabTestSampleFail,
  deleteLabTestSampleSuccess,
  getLabTestSamplesFail,
  getLabTestSamplesSuccess,
  setState,
  updateLabTestSampleFail,
  updateLabTestSampleSuccess,
} from "./actions";

import { toast } from 'react-toastify';
import { labTestSamples, updateStatus } from '../../../helpers/adipiBackendUrl';
import { deleteApiCall, getTable, patchApiCall, postApiCall } from "../../../services/mainServices";

function* fetchLabTestSamples({ payload: { params } }) {
  try {
    yield put(setState(true));
    const response = yield call(getTable, labTestSamples, params.toString());
    yield put(setState(false));
    yield put(getLabTestSamplesSuccess(response.items, response.totalPages, response.currentPage));
  } catch (error) {
    yield put(setState(false));
    yield put(getLabTestSamplesFail(error));
  }
}

function* updateLabTestSample({ payload: labTestSampleObj }) {
  try {
    const { id, recordStatus, ...rest } = labTestSampleObj;
    yield call(patchApiCall, `${labTestSamples}/${id}`, rest);
    const response = yield call(getTable, `${labTestSamples}/${labTestSampleObj.id}`);
    yield put(updateLabTestSampleSuccess(response));
    toast.success('Registro actualizado correctamente');
  } catch (error) {
    toast.error('Error al actualizar el registro');
    yield put(updateLabTestSampleFail(error));
  }
}

function* updateLabTestSampleStatus({ payload: labTestSampleObj }) {
  try {
    const { id } = labTestSampleObj;
    yield call(patchApiCall, `${labTestSamples}/${updateStatus}/${id}`, { recordStatus: labTestSampleObj.recordStatus });
    const response = yield call(getTable, `${labTestSamples}/${labTestSampleObj.id}`);
    yield put(updateLabTestSampleSuccess(response));
  } catch (error) {
    yield put(updateLabTestSampleFail(error));
  }
}

function* deleteLabTestSample({ payload: labTestSampleObj }) {
  try {
    yield call(deleteApiCall, `${labTestSamples}/${labTestSampleObj.id}`);
    yield put(deleteLabTestSampleSuccess(labTestSampleObj.id));
    toast.success('Registro borrado correctamente');
  } catch (error) {
    yield put(deleteLabTestSampleFail(error));
    toast.error('Error al borrar el registro');
  }
}

function* postingLabTestSample({ payload: labTestSample }) {
  try {
    const response = yield call(postApiCall, labTestSamples, labTestSample);
    yield put(addLabTestSampleSuccess(response));
    toast.success('Registro agregado correctamente');
  } catch (error) {
    yield put(addLabTestSampleFail(error));
    toast.error('Error al agregar el registro');
  }
}

function* labTestSamplesSaga() {
  yield takeEvery(GET_LABTESTSAMPLES, fetchLabTestSamples);
  yield takeEvery(ADD_NEW_LABTESTSAMPLE, postingLabTestSample);
  yield takeEvery(UPDATE_LABTESTSAMPLE, updateLabTestSample);
  yield takeEvery(UPDATE_LABTESTSAMPLE_STATUS, updateLabTestSampleStatus);
  yield takeEvery(DELETE_LABTESTSAMPLE, deleteLabTestSample);
}

export default labTestSamplesSaga;
